import React, { useContext } from "react";
import { Form, Alert, Button, Row, Col } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useParams } from "react-router-dom";
import { useGetAllAccountsQuery } from "../../../../../redux/slices/accounts";
import NotyfContext from "../../../../../contexts/NotyfContext";

const AccountActivationForm = ({ id }) => {
  const { account } = useGetAllAccountsQuery(undefined, {
    selectFromResult: ({ data }) => ({
      account: data.find((acc) => acc.id === parseInt(id)),
    }),
  });
  console.log("Acccount data found: ", account);
  // console.log("statatata", id);
  const notyf = useContext(NotyfContext);
  const ActivateAccount = async (email, password) => {
    try {
      const response = await axios.post("activate_account", {
        email,
        password,
      });
      return { status: response.status, message: response.data };
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <Formik
      initialValues={{
        company_name: account.company_name,
        company_email: account.company_email,
        billing_email: account.billing_email,
        support_email: account.support_email,
        phone_number: account.phone_number,
        CustomerPlanID: "",
        CustomerRouteID: "",
        DefaultSMSPrice: "",
        CurrencyID: "",
        BalanceAmount: "",
        TimeZoneID: "",
        BalanceAmount: "",
        TimeZoneID: "",
        TemplateLocked: "",
        CountryID: "",
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string()
          .email("Must be a valid email")
          .max(255)
          .required("Email is required"),
        password: Yup.string().max(255).required("Password is required"),
        user_email: Yup.string()
          .email("Must be a valid email")
          .max(255)
          .required("User email is required"),
        company_name: Yup.string().required("Company name is required"),
        company_email: Yup.string()
          .email("Must be valid email")
          .required("Company email is required"),
        support_email: Yup.string()
          .email("Must be a valid email")
          .required("Support email is required"),
        billing_email: Yup.string()
          .email("Must be a valid email")
          .required("Billing email is required"),
        phone_number: Yup.string().required("Phone number is required"),
      })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        console.log(values);
        try {
          const activation = await ActivateAccount(
            values.email,
            values.password
          );

          console.log(activation);

          setStatus({ success: true });

          if (activation.status === 200) {
            notyf.success(activation.message);
          }
        } catch (e) {
          console.log(e);
          let message = e.message || "something went wrong while activating";
          if (e.message === "activation is undefined") {
            message = "Could not connect to Server";
          }

          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <Form onSubmit={handleSubmit}>
          {errors.submit && (
            <Alert className="my-3" variant="danger">
              <div className="alert-message">{errors.submit}</div>
            </Alert>
          )}

          <Row>
            <Col>
              <Form.Group classname="mb-5">
                <Form.Label>Company name:</Form.Label>
                <Form.Control
                  size="lg"
                  type="text"
                  name="company_name"
                  placeholder=""
                  value={values.company_name}
                  isInvalid={Boolean(
                    touched.company_name && errors.company_name
                  )}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
                {!!touched.company_name && (
                  <Form.Control.Feedback type="invalid">
                    {errors.company_name}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>User email: (used when signed up)</Form.Label>
                <Form.Control
                  size="lg"
                  type="text"
                  name="user_email"
                  placeholder="User email"
                  value={values.user_email}
                  isInvalid={Boolean(touched.user_email && errors.user_email)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
                {!!touched.user_email && (
                  <Form.Control.Feedback type="invalid">
                    {errors.user_email}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
          </Row>
          <br></br>
          <h3>Contact Information</h3>
          <Row>
            <Col>
              <Form.Group classname="mb-5">
                <Form.Label>Company email</Form.Label>
                <Form.Control
                  size="lg"
                  type="email"
                  name="company_email"
                  placeholder=""
                  value={values.company_email}
                  isInvalid={Boolean(
                    touched.company_email && errors.company_email
                  )}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
                {!!touched.company_email && (
                  <Form.Control.Feedback type="invalid">
                    {errors.company_email}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Billing email:</Form.Label>
                <Form.Control
                  size="lg"
                  type="email"
                  name="billing_email"
                  placeholder=""
                  value={values.billing_email}
                  isInvalid={Boolean(
                    touched.billing_email && errors.billing_email
                  )}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
                {!!touched.billing_email && (
                  <Form.Control.Feedback type="invalid">
                    {errors.billing_email}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>Support email</Form.Label>
                <Form.Control
                  size="lg"
                  type="email"
                  name="support_email"
                  placeholder=""
                  value={values.support_email}
                  isInvalid={Boolean(
                    touched.support_email && errors.support_email
                  )}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
              </Form.Group>
              {!!touched.support_email && (
                <Form.Control.Feedback type="invalid">
                  {errors.support_email}
                </Form.Control.Feedback>
              )}
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Phonenumber:</Form.Label>
                <Form.Control
                  size="lg"
                  type="text"
                  name="phone_number"
                  placeholder="255624123123"
                  value={values.phone_number}
                  isInvalid={Boolean(
                    touched.phone_number && errors.phone_number
                  )}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
                {!!touched.phone_number && (
                  <Form.Control.Feedback type="invalid">
                    {errors.phone_number}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
          </Row>
          <br></br>
          <h3>Pricing & Routes</h3>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>Customer plan ID</Form.Label>
                <Form.Control
                  size="lg"
                  type="text"
                  name="CustomerPlanID"
                  placeholder=""
                  value={values.CustomerPlanID}
                  isInvalid={Boolean(
                    touched.CustomerPlanID && errors.CustomerPlanID
                  )}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Customer route ID</Form.Label>
                <Form.Control
                  size="lg"
                  type="text"
                  name="CustomerRouteID"
                  placeholder=""
                  value={values.CustomerRouteID}
                  isInvalid={Boolean(
                    touched.CustomerRouteID && errors.CustomerRouteID
                  )}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
          <br></br>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>Default SMS price</Form.Label>
                <Form.Control
                  size="lg"
                  type="text"
                  name="DefaultSMSPrice"
                  placeholder=""
                  value={values.DefaultSMSPrice}
                  isInvalid={Boolean(
                    touched.DefaultSMSPrice && errors.DefaultSMSPrice
                  )}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Currency ID</Form.Label>
                <Form.Control
                  size="lg"
                  type="text"
                  name="CurrencyID"
                  placeholder=""
                  value={values.CurrencyID}
                  isInvalid={Boolean(touched.CurrencyID && errors.CurrencyID)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Balance Amount</Form.Label>
                  <Form.Control
                    size="lg"
                    type="text"
                    name="BalanceAmount"
                    placeholder=""
                    value={values.BalanceAmount}
                    isInvalid={Boolean(
                      touched.BalanceAmount && errors.BalanceAmount
                    )}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>
            </Col>
          </Row>
          <br></br>
          <h3>Locale</h3>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>TimeZone</Form.Label>
                <Form.Control
                  size="lg"
                  type="text"
                  name="TimeZoneID"
                  placeholder=""
                  value={values.TimeZoneID}
                  isInvalid={Boolean(touched.TimeZoneID && errors.TimeZoneID)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>

            <Col>
              <Form.Group>
                <Form.Label>Country ID</Form.Label>
                <Form.Control
                  size="lg"
                  type="text"
                  name="CountryID"
                  placeholder=""
                  value={values.CountryID}
                  isInvalid={Boolean(touched.CountryID && errors.CountryID)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                />
              </Form.Group>
            </Col>
          </Row>
          <br></br>
          <div className="text-end mt-3">
            <Button
              type="submit"
              variant="primary"
              size="lg"
              disabled={isSubmitting}
            >
              Activate Account
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default AccountActivationForm;
